import defaultWatermarkUrl from './defaultWatermark.png';

export const loadImage = async (url: string): Promise<HTMLImageElement> => (
    new Promise<HTMLImageElement>((resolve, reject) => {
        const img = new Image();
        img.addEventListener('load', () => resolve(img));
        img.addEventListener('error', (err) => reject(err));
        img.src = url;
    })
);

export const loadDefaultWatermark = (): Promise<HTMLImageElement> => loadImage(defaultWatermarkUrl);
